import {
  HttpErrorResponse,
  HttpEventType,
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, tap } from 'rxjs';
import { SnackBarService } from '../components/snack-bar/snackBar.service';

export const errorHandlingInterceptor: HttpInterceptorFn = (req, next) => {
  //referencia al servicio de snackbar
  const snackService = inject(SnackBarService);

  return next(req).pipe(
    tap((event) => {
      if (event.type === HttpEventType.Response) {
        //mostramos snack de suceso solo si la operación es de actualización de data, esto para no mostrar snack con solicitudes de información
        if (
          (req.method == 'POST' ||
            req.method == 'PUT' ||
            req.method == 'DELETE' ||
            req.method == 'PATCH') &&
          event.status >= 200 &&
          event.status <= 299 &&
          !req.headers.has('X-Skip-Snackbar') &&
          !req.headers.has('X-Manejo-Propio')
        ) {
          let msg = '';

          switch (req.method) {
            case 'POST':
              msg = 'El registro ha sido creado con éxito.';
              break;
            case 'PUT':
              msg = 'El registro ha sido actualizado con éxito.';
              break;
            case 'PATCH':
              msg = 'El registro ha sido actualizado con éxito.';
              break;
            case 'DELETE':
              msg = 'El registro ha sido eliminado con éxito.';
              break;
          }
          snackService.displaySnackBar('success', 'Registro Actualizado', msg);
        }
      }
    }),

    catchError((err: HttpErrorResponse) => {
      console.log(err);
      if (err && !req.headers.has('X-Manejo-Propio')) {
        switch (err.status) {
          case 409:
            //en caso de problema de validación mostramos snack de error
            snackService.displaySnackBar('error', 'Error', err.error?.error?.message ?? err.error?.message ?? 'No fue posible completar la operación.');
            break;
          case 400:
            //en caso de bad request, mostramos mensaje generico porque hay problema al completar el DTO enviado
            snackService.displaySnackBar(
              'error',
              'Error',
              'Hubo un problema al iniciar la operación, por favor comuníquese con soporte'
            );
            break;
          case 404:
            console.log('Error 404: Not Found');
            break;
          case 401:
            //en caso de bad request, mostramos mensaje generico porque hay problema al completar el DTO enviado
            console.log('Error 401: Unauthorized');
            break;
          default:
            // en case de otro error mostramos snack pero con descripcion generica para no mostrar 'internal server error'
            snackService.displaySnackBar(
              'error',
              'Error',
              'Hubo un problema al completar la operación, por favor comuníquese con soporte'
            );
            break;
        }
      }
      throw err;
    })
  );
};
